import { Outlet, Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Layers, LogOut, User as UserIcon } from 'lucide-react';

export default function Layout() {
    const { user, logout } = useAuth();
    const navigate = useNavigate();

    const handleLogout = () => {
        logout();
        navigate('/login');
    };

    return (
        <div className="min-h-screen bg-neutral-950 text-neutral-100 font-sans selection:bg-purple-500/30">
            {/* Dynamic Background Gradients */}
            <div className="fixed inset-0 z-0 overflow-hidden pointer-events-none">
                <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] rounded-full bg-purple-600/10 blur-[120px]" />
                <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] rounded-full bg-blue-600/10 blur-[120px]" />
            </div>

            <nav className="relative z-10 border-b border-neutral-800 bg-neutral-950/50 backdrop-blur-xl supports-[backdrop-filter]:bg-neutral-950/20 sticky top-0">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex justify-between h-16 items-center">
                        <Link to="/" className="flex items-center space-x-2 group">
                            <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-purple-500 to-blue-600 flex items-center justify-center shadow-lg shadow-purple-500/20 group-hover:scale-105 transition-all">
                                <Layers className="text-white w-6 h-6" />
                            </div>
                            <span className="text-xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-white to-neutral-400">
                                TCGBinder
                            </span>
                        </Link>

                        <div className="flex items-center space-x-4">
                            {user ? (
                                <>
                                    <Link
                                        to="/dashboard"
                                        className="text-sm font-medium text-neutral-300 hover:text-white transition-colors"
                                    >
                                        Dashboard
                                    </Link>
                                    {user.vendor_slug && (
                                        <Link
                                            to={`/vendor/${user.vendor_slug}`}
                                            className="text-sm font-medium text-neutral-300 hover:text-white transition-colors"
                                        >
                                            My Store
                                        </Link>
                                    )}
                                    <div className="h-4 w-px bg-neutral-700 mx-2" />
                                    <button
                                        onClick={handleLogout}
                                        className="flex items-center space-x-2 text-sm text-red-400 hover:text-red-300 transition-colors"
                                    >
                                        <LogOut className="w-4 h-4" />
                                        <span>Log out</span>
                                    </button>
                                </>
                            ) : (
                                <>
                                    <Link
                                        to="/login"
                                        className="text-sm font-medium text-neutral-300 hover:text-white transition-colors"
                                    >
                                        Log in
                                    </Link>
                                    <Link
                                        to="/register"
                                        className="text-sm font-medium px-4 py-2 rounded-lg bg-white text-black hover:bg-neutral-200 transition-colors shadow-lg shadow-white/10"
                                    >
                                        Sign up
                                    </Link>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </nav>

            <main className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                <Outlet />
            </main>
        </div>
    );
}
